import React, { useState } from 'react';
import { Box, Button, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import { useForm, useFormState } from 'react-final-form';
import { declineFullName } from './nameDeclension';

type Status = { kind: 'success' | 'error'; text: string };

const DECLENSION_FIELDS = [
  'nominative',
  'genitive',
  'dative',
  'accusative',
  'instrumental',
  'prepositional',
] as const;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1),
    },
    status: {
      marginLeft: theme.spacing(3),
    },
    error: {
      color: theme.palette.error.main,
    },
    success: {
      color: theme.palette.success.main,
    },
  })
);

export const DeclensionGenerator = () => {
  const classes = useStyles();
  const form = useForm();
  const { values } = useFormState<{ firstName?: string; middleName?: string }>({
    subscription: { values: true },
  });
  const [status, setStatus] = useState<Status | null>(null);

  const handleGenerate = () => {
    const firstName = values.firstName?.trim() ?? '';
    const middleName = values.middleName?.trim() ?? '';

    if (firstName === '' || middleName === '') {
      setStatus({ kind: 'error', text: 'Сперва укажите имя и отчество подопечного' });
      return;
    }

    const declension = declineFullName(firstName, middleName);
    if (declension === null) {
      setStatus({ kind: 'error', text: 'Нет подходящих правил склонения' });
      return;
    }

    DECLENSION_FIELDS.forEach((field) => {
      form.change(`displayNameDeclension.${field}`, declension[field]);
    });
    setStatus({ kind: 'success', text: 'OK!' });
  };

  return (
    <Box className={classes.container}>
      <Button variant="outlined" color="primary" onClick={handleGenerate}>
        Сгенерировать
      </Button>
      {status && (
        <Typography
          variant="body2"
          className={`${classes.status} ${
            status.kind === 'success' ? classes.success : classes.error
          }`}
        >
          {status.text}
        </Typography>
      )}
    </Box>
  );
};
